'use strict';

import {Behavior} from "./ToggleArea";
import fd from "./promise-fastdom";

const _ = new WeakMap();

/**
 * options for scroll handling
 * @constructor
 */
export default function AccordionBehavior() {
    _.set(this, {
        instances: [],
    });
}

AccordionBehavior.prototype = new Behavior();

AccordionBehavior.prototype.init = function (instance) {
    _.get(this).instances.push(instance);
}

AccordionBehavior.prototype.beforeOpen = function (instance) {
    const o = _.get(this);

    // if another instance is open, close it
    for (const i of o.instances) {
        if (i !== instance && i.opened()) {
            handleScrollPosition(instance.area(), i.area()).then(() => i.close());
            break;
        }
    }
}

function handleScrollPosition(opening, closing) {
    const openingItem = opening.closest('li');
    const closingItem = closing.closest('li');
    let item = openingItem.previousElementSibling;
    while (item && item !== closingItem) {
        item = item.previousElementSibling;
    }
    return item ? fd.measure(() => {
        // closing is above opening, need to handle scroll position
        const height = closing.getBoundingClientRect().height;
        const top = openingItem.getBoundingClientRect().top;
        top < height && window.scrollBy({
            top: top - height,
            behavior: 'smooth',
        });
    }) : Promise.resolve();
}
